/**
 * Log diagnostici solo in modalità debug.
 *
 * Abilitazione (CRA inietta le variabili a build time):
 * - `REACT_APP_DEBUG=true` — flag principale (anche in produzione per supporto)
 * - `REACT_APP_DEBUG_SYNC=true` — compat con progetti che usavano solo la sync
 * - `NODE_ENV === 'development'` — sviluppo locale senza toccare .env
 *
 * Disabilitazione esplicita: `REACT_APP_DEBUG=false`
 */

export function isDebugEnabled(): boolean {
  if (process.env.REACT_APP_DEBUG === 'false') return false;
  return (
    process.env.REACT_APP_DEBUG === 'true' ||
    process.env.REACT_APP_DEBUG_SYNC === 'true' ||
    process.env.NODE_ENV === 'development'
  );
}

export function debugLog(...args: unknown[]): void {
  if (isDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function debugWarn(...args: unknown[]): void {
  if (isDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}

export function debugDebug(...args: unknown[]): void {
  if (isDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
}

/** Errore diagnostico (solo in modalità debug; non sostituisce error boundary / toast). */
export function debugError(...args: unknown[]): void {
  if (isDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
